import styled from "styled-components";

export const Card = styled.div`
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  overflow: hidden;
`;

export const Header = styled.div`
  padding: 16px;
  border-bottom: 1px solid #e5e7eb;
  background: #f9fafb;
`;

export const Title = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: #111827;
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
`;

export const Content = styled.div`
  padding: 16px;
  display: flex;
  gap: 12px;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 50%;
`;

export const Field = styled.div``;

export const FieldLabel = styled.p`
  font-size: 12px;
  color: #6b7280;
  margin: 0 0 4px 0;
`;

export const FieldValue = styled.p`
  font-weight: 500;
  color: #111827;
  margin: 0;
`;

export const StatusBadge = styled.span<{ status: string }>`
  display: inline-block;
  padding: 4px 8px;
  font-size: 12px;
  font-weight: 500;
  border-radius: 4px;
  background-color: ${props =>
    props.status === "Ativo" ? "#dcfce7" : "#f3f4f6"};
  color: ${props => (props.status === "Ativo" ? "#166534" : "#374151")};
`;
